/**
 * This class is meant to represent any custom (non-ViewerMaterialWrapper) material that can be applied to a SceneObject
 */
export class CustomMaterialWrapper {
    constructor(material) {
        this.material = material;
    }
}
//# sourceMappingURL=CustomMaterialWrapper.js.map